"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardView = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var Types = require("types");
var components_1 = require("components");
var translate_1 = require("utils/translate");
var avatars_1 = require("components/Avatar/avatars");
var Icon_1 = require("components/Icon");
require("./style.scss");
var zendesk = null;
var avatar = (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9');
var mapStateToProps = function (state) {
    return {
        currentUser: state.auth.current.user,
        auth: state.auth,
        zToken: state.auth.zendesk.token,
        projects: state.projects,
        selectedLanguage: (0, translate_1.getLanguage)()
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchProjects: function (params) {
        return dispatch(ProjectActions.fetchProjects(params));
    },
    clear: function () { return dispatch(ProjectActions.clear()); },
    zendeskToken: function () { return dispatch(AuthActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(AuthActions.resetZendeskToken()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DashboardView'), (0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchProjects({
            limit: 12,
            offset: 0,
            orderBy: 'visitedAt',
            order: 'desc'
        });
    },
    componentWillUnmount: function () {
        this.props.clear();
    },
    componentDidUpdate: function (prevProps) {
        if (zendesk &&
            this.props.zToken !== '' &&
            this.props.zToken !== prevProps.zToken) {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(this.props.zToken, "&return_to=https://sokopro.zendesk.com/");
            zendesk.location.href = url;
            zendesk.focus();
            zendesk = null;
            this.props.clearToken();
        }
        if (this.props.searchString !== prevProps.searchString) {
            this.props.fetchProjects({
                limit: 6,
                offset: 0,
                name: this.props.searchString,
                order: 'desc',
                orderBy: 'visitedAt'
            });
        }
    }
}), recompose_1.pure);
exports.DashboardView = enhance(function (props) {
    return (React.createElement("div", { key: "main-content", className: 'content-wrapper-content' },
        React.createElement("div", { className: 'dashboard-view' },
            React.createElement("main", { className: "content" },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/") }, "SokoPro"),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/dashboard'))),
                React.createElement(components_1.Greeting, { message: (0, translation_1.getLocalization)('dashboard/pleaseCheckTheLatestUpdates') }),
                React.createElement("div", null,
                    React.createElement(components_1.ResponsiveButtonBar, null,
                        props.currentUser
                            .map(function (x) { return x.level === 'SuperAdminUserGroup' || false; })
                            .fold(null, function (x) {
                            return x ? (React.createElement(sok_ui_1.Button, { color: "green", icon: React.createElement(Icon_1.Icon, { className: "fa-plus" }), url: "/".concat(props.selectedLanguage, "/admin/projects") }, (0, translation_1.getLocalization)('dashboard/newProject'))) : null;
                        }),
                        React.createElement(sok_ui_1.Button, { color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: "fa-book" }), onClick: function () {
                                zendesk = window.open('about:blank', 'blank');
                                props.zendeskToken();
                            } }, (0, translation_1.getLocalization)('dashboard/tutorials')))),
                React.createElement(sok_ui_1.BoxLayout, null,
                    React.createElement(sok_ui_1.BoxLayout, { direction: "column" },
                        React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)('dashboard/myProjects'), footer: React.createElement(react_router_dom_1.Link, { className: "show-more", to: "/".concat(props.selectedLanguage, "/projects") }, (0, translation_1.getLocalization)('dashboard/showMore')) },
                            React.createElement("div", { className: "search-projects" },
                                React.createElement(sok_ui_1.TextInput, { className: 'sok-text-input white search-box', value: props.searchString, placeholder: (0, translation_1.getLocalization)('dashboard/searchProjects'), onChange: function (e) {
                                        return props.setSearchString(e.target.value);
                                    }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }) })),
                            props.projects.projectListStatus === 'FETCHING' && (React.createElement("div", { className: "fetching-projects" },
                                React.createElement(Icon_1.Icon, { className: "fa-spinner fa-spin fa-2x" }))),
                            props.projects.projectListStatus === 'FETCHED' &&
                                props.projects.projects.length > 0 ? (React.createElement(sok_ui_1.PanelList, { className: 'my-projects-list' }, props.projects.projects.map(function (project, i) { return (React.createElement("li", { key: i },
                                React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/") + project.id }, project.name))); }))) : (props.projects.projectListStatus === 'FETCHED' &&
                                props.projects.projects.length === 0 &&
                                (props.searchString.length === 0 ? (React.createElement("div", { className: 'no-projects-available' },
                                    React.createElement("div", null,
                                        React.createElement("img", { src: avatar })),
                                    React.createElement("span", { className: 'no-projects-dear' },
                                        React.createElement("b", null, (0, translation_1.getLocalization)('pushNotifications/dearSokoproUser'))),
                                    React.createElement("span", null, (0, translation_1.getLocalization)('thereAreNoProjects')),
                                    React.createElement("span", null, (0, translation_1.getLocalization)('pleaseContactHelpdesk')))) : (React.createElement("div", { className: 'no-projects-available' },
                                    React.createElement("div", null,
                                        React.createElement("img", { src: avatar })),
                                    React.createElement("span", { className: 'no-projects-dear' },
                                        React.createElement("b", null, (0, translation_1.getLocalization)('pushNotifications/dearSokoproUser'))),
                                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/noProjectsWithSearchWord')))))))))))));
});
exports.default = exports.DashboardView;
